module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "sidebar-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("MENU DE NAVEGAÇÃO")]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Consulta")])])]), _vm._v(" "), (this.$store.state.user.nivel == 'administrador') ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/empresas"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-bank"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Empresas")])])]) : _vm._e(), _vm._v(" "), (this.$store.state.user.nivel == 'administrador') ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/usuarios"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-users"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Usuários")])])]) : _vm._e(), _vm._v(" "), (this.$store.state.user.nivel == 'administrador') ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/fechamento"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-money"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Fechamento")])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-440edfc8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SidebarMenu.vue
// module id = 164
// module chunks = 1